<template>

    <Toast/>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a @click="processSetGoals" class="cursor-pointer text-900 white-space-nowrap">Plan</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a @click="processSetGoals" class="cursor-pointer text-900 white-space-nowrap">Set Goals</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Enter your details below to see your progress toward financial freedom on the Achieve dashboard.
                </span>
            </div>
        </div>

        <div v-show="activeTab === 1" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Set Goals</h3>

                    <div class="field">
                        <span>Functionality not available with current subscription. Please upgrade to view functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Plan</h3>

                    <div class="field">
                        <span>Future enhancement coming soon, will provide personalized planning functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 3" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <div class="field">
                        <label for="freedomGoal">My annual financial freedom income goal</label>
                        <InputNumber
                            id="amount"
                            v-model="userConfiguration.siFreedomGoal"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="0"/>
                    </div>

                    <div class="field">
                        <label for="freedomYear">My financial freedom year</label>
                        <Dropdown v-model="userConfiguration.siFreedomYear"
                                  :options="years"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>

                    </div>

                    <div class="field">
                        <label for="currency">My base currency</label>
                        <Dropdown v-model="userConfiguration.siPlanCurrency"
                                  :options="currencyTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Currency"/>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="savePlanConfiguration"></Button>

                </div>
            </div>
        </div>

    </div>


    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import numeral from "numeral";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        this.loading = true;

        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            const pingData = await UserService.getUserPing();
            console.log("[Applications][mounted] System is active.");
            console.log("[Applications][mounted] Data = ", pingData);
        } catch (e) {
            console.log("[Applications][mounted] System is NOT active.");
            console.log("[Applications][mounted] Error = ", e);

            this.userStore.clearUser();
            this.$router.replace('/siLogin');
            return;
        }

        if (this.userStore.user === undefined) {
            console.log("[Applications][mounted] User is NOT defined.");

            this.userStore.clearUser();
            this.$router.replace('/siLogin');
        } else {
            console.log("[Applications][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            try {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
                console.log("[Applications][mounted] Data = ", userData);

                if (this.profile.rights === 'C') {
                    this.activeTab = 1;
                } else {
                    this.activeTab = 3;
                }

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfiguration = userConfigData.data;
                    console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
                } catch (e) {
                    console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.replace('/siLogin');
                    }
                    return;

                }

                if (this.userConfiguration.enableSiUs === 'Y') {
                    var newEntry1 = {name: 'NYSE', code: 'NYSE'};
                    var newEntry2 = {name: 'NASDAQ', code: 'NASDAQ'};

                    var newCurrencyEntry1 = {name: 'USD', code: 'USD'};

                    this.exchanges.push(newEntry1);
                    this.exchanges.push(newEntry2);

                    this.currencyTypes.push(newCurrencyEntry1);
                }

                if (this.userConfiguration.enableSiCa === 'Y') {
                    var newEntry3 = {name: 'TSX', code: 'TO'};

                    var newCurrencyEntry2 = {name: 'CAD', code: 'CAD'};

                    this.exchanges.push(newEntry3);

                    this.currencyTypes.push(newCurrencyEntry2);
                }

                if (this.userConfiguration.enableSiUk === 'Y') {
                    var newEntry4 = {name: 'LSE', code: 'LSE'};

                    var newCurrencyEntry3 = {name: 'GBP', code: 'GBP'};

                    this.exchanges.push(newEntry4);

                    this.currencyTypes.push(newCurrencyEntry3);
                }

                if (this.userConfiguration.enableSiZa === 'Y') {
                    var newEntry5 = {name: 'JSE', code: 'JSE'};

                    var newCurrencyEntry4 = {name: 'ZAR', code: 'ZAR'};

                    this.exchanges.push(newEntry5);

                    this.currencyTypes.push(newCurrencyEntry4);
                }

                console.log("[Plan][mounted] this.exchanges = ", this.exchanges);

                if (this.exchanges.length > 0) {
                    this.selectedExchange = this.exchanges[0].code;
                }

                console.log("[Plan][mounted] this.selectedExchange = ", this.selectedExchange);

                this.loading = false;

            } catch (e) {
                console.log("[Applications][mounted] No user data found.");
                console.log("[Applications][mounted] Error = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    // this.$router.replace('/siLogin');
                }
                return;
            }

            this.loading = false;
        }
    },
    data() {

        return {
            profile: {},
            userConfiguration: {},
            activeTab: 3,
            loading: false,
            submitted: false,
            currencyTypes: [],
            exchanges: [],
            years: [
                {name: 2025, code: 2025},
                {name: 2026, code: 2026},
                {name: 2027, code: 2027},
                {name: 2028, code: 2028},
                {name: 2029, code: 2029},
                {name: 2030, code: 2030},
                {name: 2031, code: 2031},
                {name: 2032, code: 2032},
                {name: 2033, code: 2033},
                {name: 2034, code: 2034},
                {name: 2035, code: 2035},
                {name: 2036, code: 2036},
                {name: 2037, code: 2037},
                {name: 2038, code: 2038},
                {name: 2039, code: 2039},
                {name: 2040, code: 2040},
                {name: 2041, code: 2041},
                {name: 2042, code: 2042},
                {name: 2043, code: 2043},
                {name: 2044, code: 2044},
                {name: 2045, code: 2045},
                {name: 2046, code: 2046},
                {name: 2047, code: 2047},
                {name: 2048, code: 2048},
                {name: 2049, code: 2049},
                {name: 2050, code: 2050}
            ],
        }
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        processSetGoals() {
            console.log("[MenuConfiguration][processSetGoals] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siSetGoals');
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        formatNumeric(value) {
            if (value) {
                return numeral(value).format('0,0'); // Returns a formatted string with thousand separators
            } else {
                return '0'; // Ensure consistency by returning a string
            }
        },
        formatString(value) {
            if (value) {
                const formattedValue = String(value).substring(0, 50);
                return formattedValue;
            } else {
                return '';
            }
        },
        async savePlanConfiguration() {
            this.submitted = true;
            this.loading = true;

            try {
                var newDataDto = {
                    siFreedomGoal: this.userConfiguration.siFreedomGoal,
                    siFreedomYear: this.userConfiguration.siFreedomYear,
                    siPlanCurrency: this.userConfiguration.siPlanCurrency
                };

                console.log('[Plan][savePlanConfiguration] this.userStore.user.id = ', this.userStore.user.id);
                console.log('[Plan][savePlanConfiguration] newDataDto = ', newDataDto);

                const response = await UserService.updateUserConfig(this.userStore.user.id, newDataDto);

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfiguration = userConfigData.data;
                    console.log("[Plan][savePlanConfiguration] userConfigData.data = ", userConfigData.data);
                } catch (e) {
                    console.error("[Plan][savePlanConfiguration] Could not find user config for user = ", this.userStore.user.id);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;

                }

                console.log('[Plan][savePlanConfiguration] Response = ', response);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Updated plan information',
                    life: 3000
                });

            } catch (e) {
                console.error('[Plan][savePlanConfiguration] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update plan information. Please try again.',
                    life: 3000
                });

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            this.activeTab = 3;
            this.submitted = false;
            this.loading = true;

        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
}

.highlight {
    background-color: #7cd9d1; /* Example: light red */
    color: black; /* Text color */
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-DT {
        background: #E5C7BCFF;
        color: #BE5306FF;
    }
}
</style>
